import { InlineEditorAction, InlineEditorActionType, SetSelectionActive } from "./InlineEditorActions";
import { InlineEditorState } from "./InlineEditorState";

export const InlineEditorReducer = (state: InlineEditorState, action: InlineEditorAction): InlineEditorState => {
    switch (action.type) {
        case InlineEditorActionType.SetSelectionActive:
            if (state.selectionActive === action.payload.hasSelection) return state;
            return { ...state, selectionActive: action.payload.hasSelection };

        default:
            return state;
    }
};

export const setSelection = (hasSelection: boolean): SetSelectionActive => ({
    type: InlineEditorActionType.SetSelectionActive,
    payload: { hasSelection },
});
